import { createSelector } from 'reselect';
import get from 'lodash/get';
import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';
import { selectAppDomain } from '../App/selectors';

const selectSeasonsPageDomain = state => state.SeasonsPage || initialState;

const selectSeasonsList = () => createSelector(selectSeasonsPageDomain, subState => get(subState, 'seasons'));
const selectProductionList = () =>
  createSelector(selectSeasonsPageDomain, subState => get(subState, 'seasonsProduction'));
const selectSeasons = () => createSelector(selectSeasonsList(), seasonsList => get(seasonsList, 'data'));
const selectSeasonProductions = () => createSelector(selectProductionList(), seasonsList => get(seasonsList, 'data'));
const selectCountriesList = () => createSelector(selectSeasonsPageDomain, subState => get(subState, 'countries'));
const selectCountries = () => createSelector(selectCountriesList(), countriesList => get(countriesList, 'data'));

const selectSeasonsOptions = () =>
  createSelector(selectSeasons(), seasons => createSelectFieldOptions(seasons, 'id', 'name', '', 'slug'));

const selectSeasonCompaniesList = () =>
  createSelector(selectSeasonsPageDomain, subState => get(subState, 'seasonCompanies'));

const selectSeasonCompanies = () =>
  createSelector(selectSeasonCompaniesList(), seasonCompaniesList => get(seasonCompaniesList, 'data'));

const selectLoadingSeasonCompanies = () =>
  createSelector(selectSeasonCompaniesList(), seasonCompaniesList => get(seasonCompaniesList, 'loading'));

const selectCountriesOptions = () =>
  createSelector(selectCountries(), countries => createSelectFieldOptions(countries, 'id', 'name', {}, true));

const selectAggregationCompaniesListOptions = (withAllData = false) =>
  createSelector(selectAppDomain, subState => {
    const companies = get(subState, 'aggregations.company_id', []);
    return createSelectFieldOptions(companies, 'id', 'name', {}, withAllData);
  });

const selectSeasonsLoading = () => createSelector(selectSeasonsList(), subState => get(subState, 'loading'));

export {
  selectAggregationCompaniesListOptions,
  selectCountriesOptions,
  selectLoadingSeasonCompanies,
  selectSeasonCompanies,
  selectSeasonCompaniesList,
  selectSeasons,
  selectSeasonsOptions,
  selectSeasonProductions,
  selectSeasonsLoading,
};
